import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { Badge, BadgeProps } from "reactstrap";
import { CSSObject, CSSProperties } from "styled-components";

export interface ControlChipProps extends React.HTMLAttributes<HTMLElement> {
    backgroundColor?: string | undefined;
    color?: string | undefined;
    controlStyles?: IControlStyles | undefined;
    pill?: boolean | undefined;
}

export const ComponentProps = (props: ControlChipProps): BadgeProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.backgroundColor;
    delete componentProps.color;
    delete componentProps.controlStyles;
    delete componentProps.pill;
    
    return componentProps;
}

export const ControlChip: React.FC<ControlChipProps> = (props) => {
    const styles: IControlStyles = props?.controlStyles ?? useControlStyles();
    const classInfo = props.pill ? " badge rounded-pill" : " badge";
    const className: string = props.className !== undefined ? props.className + classInfo : classInfo;

    const controlStyle: CSSProperties | undefined = { ...styles.chip ?? styles.input, ...props.style };
    if (props.backgroundColor !== undefined) {
        controlStyle.backgroundColor = props.backgroundColor;
    }

    if (props.color !== undefined) {
        controlStyle.color = props.color;
    }

    return (
        <span {...ComponentProps(props)} className={className} style={controlStyle} />
    );
};